import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import TableImage from "../../../../Componets/Image";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import { get_all_invoices } from "../../../../Controllers/Sales/Invoices";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Sales/Invoices/tables";
import headers from "../../../../Data/Tables/Sales/Invoices/headers";
import ValueTag from "../../../../Componets/Valuetag";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import { useLocation } from "react-router-dom";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";

const InvoicesTable = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();
  const [previousPage, setPreviousPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      payment: headerdata?.payment,
      sort: headerdata?.sort,
      supplier: headerdata?.supplier,
      contractor: headerdata?.contractor,
      date: headerdata?.date,
      due_date: headerdata?.due_date,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    if (data?.search && !isSearching) {
      setPreviousPage(pagination.currentPage);
      setIsSearching(true);
    }

    if (!data?.search && isSearching) {
      setIsSearching(false);
      fetchData({
        ...data,
        currentPage: previousPage,
        totalCount: pagination?.totalCount,
        totalPages: pagination?.totalPages,
      });
      return;
    }

    let page = data?.search ? 1 : pagination?.currentPage;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      payment: headerdata?.payment,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        payment: tabledata?.payment,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
        page: tabledata?.currentPage,
      };

      const invoices = await get_all_invoices(data);
      if (invoices?.status) {
        let data = [];

        invoices?.data?.data?.map((value, index) => {
          data?.push({
            path: `/app/sales/invoices/view/${value?._id}`,
            Number: `#INV-${value?.number}`,
            Customer: value?.customer?.name && value?.customer?.phone
              ? `${value?.customer?.name} (${value?.customer?.phone}) (${value?.customer?.code})`
              : value?.customer?.name
                ? `${value?.customer?.name} (${value?.customer?.code})`
                : value?.customer?.phone
                  ? `${value?.customer?.phone} (${value?.customer?.code})`
                  : "Walk-in-customer",
            Date: <DateTimeBadge date={value?.date} />,
            Due: value?.due_date
              ? new Date(value?.due_date).toLocaleString("en-GB", {
                timeZone: "Asia/Muscat",
                hour12: true,
                day: "numeric",
                month: "numeric",
                year: "numeric",
              })
              : "",
            "Billed By": value?.created_by?.name,
            Total: value?.total?.toFixed(3),
            Delivery:
              value?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : value?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
            "Payment Type":
              value?.payments?.length > 0
                ? value.payments.map((v, i) => (
                  <div className="text-xs" key={i}>
                    {v?.name} : {v?.amount?.toFixed?.(3)}
                  </div>
                ))
                : "",
            Payment:
              value?.payment_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : value?.payment_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/sales/invoices/edit/${value?._id}`}
                id={value?._id}
                api="delete-invoice"
                actiondata={actiondata}
                source={"Sales"}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: invoices?.data?.currentPage,
          totalCount: invoices?.data?.totalCount,
          totalPages: invoices?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(invoices?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default InvoicesTable;
